import request from '../../request';
import { constructUrlObject } from '../../../utils/shared/urlUtils';
import { PARAM } from '../../../constants/shared/ApiConstants';

const {
    PERIODS,
    STUDENT_IDS,
    STUDENT_UID,
    SCHOOL_YEAR,
    MEASURE,
    GOAL_VALUE,
    PERIOD,
    GRADE_LEVEL,
    STAFF_UID,
} = PARAM;

class StudentGoalsClient {
    static getStudentGoals = (studentIds, schoolYear, url) => {
        const urlWithQueryParams = constructUrlObject(url, {
            [STUDENT_IDS]: studentIds.join(),
            // Starting from 03/20/2025, Classroom Reports will support the Summer period.
            // However, since the ZoG API currently does not handle this period,
            // we are hard-coding support for only three periods for now.
            [PERIODS]: [PERIOD.BOY, PERIOD.MOY, PERIOD.EOY].join(),
            [SCHOOL_YEAR]: schoolYear,
        });
        return request.get(urlWithQueryParams);
    };

    static saveStudentGoal = (
        { studentId, measure, goalValue, period, schoolYear, grade },
        staffId,
        url,
    ) => {
        const studentGoal = {
            [STUDENT_UID]: studentId,
            [MEASURE]: measure,
            [GOAL_VALUE]: goalValue,
            [PERIOD]: period,
            [SCHOOL_YEAR]: schoolYear,
            [GRADE_LEVEL]: grade,
            [STAFF_UID]: staffId,
        };
        return request.post(url, studentGoal);
    };
}

export default StudentGoalsClient;
